const isDev = process.env.NODE_ENV === 'development';
const logger = {
  error: (...a) => { if (isDev) console.error(...a); },
  log: (...a) => { if (isDev) console.log(...a); },
};
export default logger;
